/*
 * action types
 */

// data actions
export const DASHBOARD_LOADED = "DASHBOARD_LOADED";
export const USER_NOT_LOGGED_IN = "USER_NOT_LOGGED_IN";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const SET_ACTIVE_CASE = "SET_ACTIVE_CASE";
export const REFERRALS_LOADING = "REFERRALS_LOADING";
export const REFERRALS_LOADED = "REFERRALS_LOADED";
export const REFERRALS_LOAD_FAILED = "REFERRALS_LOAD_FAILED";

/*
 * action creators
 */
export function dashboardLoaded(dashboardData) {
  return {
    type: DASHBOARD_LOADED,
    dashboardData,
  };
}

export function userNotLoggedIn() {
  return {
    type: USER_NOT_LOGGED_IN,
  };
}

export function userLoggedOut() {
  return {
    type: USER_LOGGED_OUT,
  };
}

export function setActiveCase(caseRef, caseScreen) {
  return {
    type: SET_ACTIVE_CASE,
    caseRef,
    caseScreen,
  };
}

export function referralsLoading() {
  return {
    type: REFERRALS_LOADING,
  };
}

// referralsData is the /api/dashboard/referrals response.
export function referralsLoaded(referralsData) {
  return {
    type: REFERRALS_LOADED,
    referralsData,
  };
}

export function referralsLoadFailed() {
  return {
    type: REFERRALS_LOAD_FAILED,
  };
}
